import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTheme } from "next-themes";
import { CheckCircle2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const orderId = params.get("orderId") || params.get("transactionId") || "";
  const { theme, setTheme } = useTheme();

  // Force LIGHT mode on this public page; restore admin's theme on unmount.
  useEffect(() => {
    const prev = theme;
    setTheme("light");
    return () => { if (prev && prev !== "light") setTheme(prev); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4" data-testid="payment-success-page">
      <Card className="w-full max-w-md text-center bg-white border-gray-200">
        <CardContent className="p-8 space-y-4">
          <CheckCircle2 size={56} className="mx-auto text-emerald-500" />
          <h1 className="text-2xl font-bold text-gray-900">Payment Received</h1>
          <p className="text-gray-500">Thank you! Your payment has been received and a Square receipt has been emailed to you.</p>
          {orderId && (
            <p className="text-[11px] font-mono text-gray-400 pt-2 border-t border-gray-100 break-all">
              Square ref: {orderId}
            </p>
          )}
          <p className="text-xs text-gray-400">You can close this window.</p>
        </CardContent>
      </Card>
    </div>
  );
}
